import { forwardRef, MouseEvent } from "react";
import styled from "@emotion/styled";
import { alpha } from "@kaltura/mediaspace-shared-styled";

type Props = {
    className?: string;
    data: number /** data to show */;
    onClick?: (ev: MouseEvent<HTMLDivElement>) => void /** click handler */;
    variant?: "translucent" | "normal";
    size?: "small" | "medium";
    roundness?: number;
    clickable?: boolean;
};

const StyledCounter = styled("div")<{
    variant: "translucent" | "normal";
    size: "small" | "medium";
    roundness?: number;
    clickable?: boolean;
}>(({ theme, variant, size, roundness, clickable = true }) => ({
    borderRadius: roundness ?? theme.kaltura.shape.roundness2,
    backgroundColor: theme.kaltura.palette.tone6,
    color: theme.kaltura.palette.tone1,
    ...(
        variant === "translucent" && {
            backgroundColor: alpha(theme.kaltura.palette.primary.main, 0.2),
            color: theme.kaltura.palette.tone8,
        }
    ),
    fontWeight: "bold",

    display: "flex",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    width: size === "medium" ? 64 : 36,
    height: size === "medium" ? 64 : 36,
    boxSizing: "border-box",
    cursor: clickable ? "pointer" : undefined,
}));

export const Counter = forwardRef<HTMLDivElement, Props>(
    ({ className, onClick, data, variant = "translucent", size = "small", roundness, clickable }, ref) => (
        <StyledCounter
            ref={ref}
            onClick={onClick}
            className={className}
            variant={variant}
            size={size}
            roundness={roundness}
            clickable={clickable}
        >
            <div>+{data}</div>
        </StyledCounter>
    )
);

export default Counter;
